import { Division } from "../../models/ordering/enums/division";
import { DOCUMENT_EXTENSIONS, DOCUMENT_REQUEST_LOCATION, IDocumentRequest } from "../../models/utilities/document-request";
import { API_METHODS } from "../../models/utilities/type-models";
import { ReportListType, ReportWindowsListType } from "../../modules/reports/models/report-list-type";
import { ProductionLine } from "../../production/models/enums/production-line";
import { ApiEndpoints } from "../../utils/app-constants";
import { toCondensedDate } from "../../utils/date-utils";

export class DocumentSingleReport implements IDocumentRequest {

    public filename: string = '';
    public fileExtension: DOCUMENT_EXTENSIONS = 'pdf';
    public openInTab: boolean = false;
    public url: string = '';
    public reportLocation: DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType: API_METHODS = 'GET';

    constructor(runId: number, productionLine: ProductionLine, reportName: string, listType?: ReportListType, windowsListType?: ReportWindowsListType, division?: Division) {

        const searchParams = new URLSearchParams();
        searchParams.append('RunId', runId.toString());
        searchParams.append('Line', Number(productionLine).toString());
        searchParams.append('Report', reportName);

        if (listType !== undefined ) {
            searchParams.append('ListType', Number(listType).toString());
        }
        if (windowsListType !== undefined) {
            searchParams.append('WindowsListType', Number(windowsListType).toString());
        }
        if (division !== undefined) {
            searchParams.append('Division', Number(division).toString());
        }        

        var args = searchParams.toString();

        this.url = ApiEndpoints.PRODUCTION_SINGLE_REPORT.formattify(runId) + '?' + args;
        this.filename = `ProductionRun_Paperwork_${toCondensedDate(new Date()) }`;
    }

}
